const setFrom = (itemsPerPage, pageNo) => itemsPerPage * (pageNo - 1) + 1;
const setTo = (itemsPerPage, pageNo, pageSize) =>
  itemsPerPage * (pageNo - 1) + pageSize;

export const paginationReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'INIT': {
      const totalPage = Math.ceil(payload.itemsCount / payload.itemsPerPage);
      const data = payload.items ?? [];
      const newState = {
        ...state,
        data,
        filter: payload.filter,
        totalPage,
        totalItems: payload.itemsCount,
        itemsPerPage: payload.itemsPerPage,
        canNextPage: totalPage > payload.currentPage,
        canPreviousPage: payload.currentPage > 1,
        currentPage: payload.currentPage,
        itemsLoaded: true,
        paginationArray: Array.from(Array(totalPage).keys()).map(
          item => item + 1
        ),
        from: setFrom(payload.itemsPerPage, payload.currentPage),
        to: setTo(payload.itemsPerPage, payload.currentPage, data.length)
      };
      return newState;
    }
    case 'NEXT_PAGE': {
      const data = payload.items;
      const newState = {
        ...state,
        data,
        currentPage:
          state.currentPage < state.totalPage
            ? state.currentPage + 1
            : state.currentPage,
        canNextPage: state.totalPage > state.currentPage + 1,
        canPreviousPage: state.totalPage > 1,
        from: setFrom(state.itemsPerPage, state.currentPage + 1),
        to: setTo(state.itemsPerPage, state.currentPage + 1, data.length)
      };
      return newState;
    }
    case 'PREVIOUS_PAGE': {
      const data = payload.items;
      return {
        ...state,
        data,
        currentPage:
          state.currentPage > 1 ? state.currentPage - 1 : state.currentPage,
        canNextPage: state.totalPage > 1,
        canPreviousPage: state.currentPage - 1 > 1,
        from: setFrom(state.itemsPerPage, state.currentPage - 1),
        to: setTo(state.itemsPerPage, state.currentPage - 1, data.length)
      };
    }
    case 'GO_TO_PAGE': {
      const data = payload.items;
      return {
        ...state,
        data,
        currentPage: payload.pageNo,
        canNextPage: state.totalPage > payload.pageNo,
        canPreviousPage: payload.pageNo > 1,
        from: setFrom(state.itemsPerPage, payload.pageNo),
        to: setTo(state.itemsPerPage, payload.pageNo, data.length)
      };
    }
    default:
      return state;
  }
};
